import { defineMessages } from 'react-intl';

/** Shared copy for the admin impersonation screen. */
export const impersonationMessages = defineMessages({
  pageTitle: {
    id: 'impersonation.pageTitle',
    defaultMessage: 'Impersonar usuario',
  },
  searchLabel: {
    id: 'impersonation.searchLabel',
    defaultMessage: 'Buscar usuario para impersonar',
  },
  currentUserTitle: {
    id: 'impersonation.currentUserTitle',
    defaultMessage: 'Usuario guardado',
  },
  tabDeepLinkUserTitle: {
    id: 'impersonation.tabDeepLinkUserTitle',
    defaultMessage: 'Usuario de este tab',
  },

  recentUsersTitle: {
    id: 'impersonation.recentUsersTitle',
    defaultMessage: 'Usuarios impersonados recientemente',
  },
  clearTabAuthAsAriaLabel: {
    id: 'impersonation.clearTabAuthAsAriaLabel',
    defaultMessage: 'Limpiar usuario del tab',
  },
  tabAuthAsBadgeLabel: {
    id: 'impersonation.tabAuthAsBadgeLabel',
    defaultMessage: 'Tab',
  },
  tabAuthAsBadgeTooltip: {
    id: 'impersonation.tabAuthAsBadgeTooltip',
    defaultMessage: 'Impersonación solo en este tab',
  },
  openInNewTabAriaLabel: {
    id: 'impersonation.openInNewTabAriaLabel',
    defaultMessage: 'Impersonar en tab',
  },
  deleteAriaLabel: {
    id: 'impersonation.deleteAriaLabel',
    defaultMessage: 'Eliminar',
  },
  impersonateAriaLabel: {
    id: 'impersonation.impersonateAriaLabel',
    defaultMessage: 'Impersonar',
  },
  enterToSelect: {
    id: 'impersonation.enterToSelect',
    defaultMessage: 'Enter para seleccionar',
  },
  clientAdminChip: {
    id: 'impersonation.clientAdminChip',
    defaultMessage: 'Admin cliente',
  },
});

/** Autocomplete group headers keyed by ImpersonationUserGroupKey. */
export const impersonationGroupMessages = defineMessages({
  mediainbox: {
    id: 'impersonation.groups.mediainboxUsers',
    defaultMessage: 'Usuarios Mediainbox',
  },
  client_admin: {
    id: 'impersonation.groups.clientAdmins',
    defaultMessage: 'Administradores de cliente',
  },
  client_user: {
    id: 'impersonation.groups.clientUsers',
    defaultMessage: 'Usuarios de cliente',
  },
});
